import React from 'react';
import DataAnalytics from '../pages/DataAnalytics';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


const AppRouter = () => (
    <Router>
        <Routes>
            <Route path="/" element={<DataAnalytics />} />
            <Route path="/data-analytics" element={<DataAnalytics />} />
        </Routes>
    </Router>
);

export default AppRouter;